import { Routes } from '@angular/router';
import { NpAuthChildGuard, NpPermission } from '@newpla/common';
import { Error403Component } from './app-default-pages/error/error403/error403.component';
import { Error404Component } from './app-default-pages/error/error404/error404.component';
import { LoginComponent } from './app-default-pages/login/login.component';

export const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'error/403', component: Error403Component },
  { path: 'error/404', component: Error404Component },
  // TMS 차량 위치 도면 링크 (로그인 없음, NDS-PDI-008)
  {
    path: 'view/zone-location', loadComponent: () => import('@sls-nova/shared-admin/nova-admin-features/02_yms-features/yard-zone-location-view/yard-zone-location-view.component').then(m => m.YardZoneLocationViewComponent)
  },
  {
    path: 'app', loadChildren: () => import('./app-main/app-main.module').then(m => m.AppMainModule),
    data: { permission: new NpPermission(true, [], []) }, canActivateChild: [NpAuthChildGuard]
  },
  {
    path: 'npx/sysadmin', loadChildren: () => import('@sls-nova/shared-admin/npx-admin/npx-app-sysadmin/npx-sysadmin.routes').then(m => m.routes),
    data: { permission: new NpPermission(true, ['SYS_ADMIN'], []) }, canActivateChild: [NpAuthChildGuard]
  },
  // # dev, demo, test ###########
  {
    path: 'npbt', loadChildren: () => import('../../../newpla-boot-test/npbt.routes').then(m => m.routes)
  },
  { path: '**', redirectTo: 'error/404' }
];
